/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './edit-site-asset.scss';

/* eslint-disable import/no-unresolved, import/default */

import editSiteAssetTemplate from './edit-site-asset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.admin.editSiteAsset', [])
    .directive('agEditSiteAsset', EditSiteAsset)
    .name;

/*@ngInject*/
function EditSiteAsset() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: EditSiteAssetController,
        controllerAs: 'vm',
        templateUrl: editSiteAssetTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function EditSiteAssetController($rootScope, $scope, $q, $timeout, $translate, types, agTypes, userService, entityRelationService, siloService, siloGroupService, aerationService, weatherStationService) {

    let vm = this;

    vm.agTypes = agTypes;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN';
    vm.siteAsset = null;

    vm.moveNameId = moveNameId;
    vm.detailsNameId = detailsNameId;

    vm.copySiteAsset = copySiteAsset;
    vm.moveSiteAsset = moveSiteAsset;
    vm.gotoSiteAssetDetails = gotoSiteAssetDetails;
    vm.save = save;
    vm.cancel = cancel;

    var defaultTitle = $translate.instant('ag.site.site-asset') + '';


    $scope.$watch('vm.ctx', function() {
        if (vm.showData && vm.ctx) {
            vm.isEdit = vm.ctx.isEdit;
            vm.ctx.widgetTitle = defaultTitle;
        }
    });

    $scope.$watch(function() { return vm.siteAsset ? vm.siteAsset.name : defaultTitle; }, function(title) {
        if (vm.showData && vm.ctx) {
            vm.ctx.widgetTitle = title;
        }
    });

    $scope.$on('editModeChanged', function() {
        vm.isEdit = vm.ctx.isEdit;
    });

    $scope.$on('siteAssetSelected', function(event, siteAssetId, siteAssetType) {
        if (vm.showData) {
            reload(siteAssetId, siteAssetType);
        }
    });

    $scope.$on('siteAssetPositionUpdated', function(event, siteAsset) {
        if (vm.showData) {
            if (vm.siteAsset && angular.equals(vm.siteAsset.id, siteAsset.id)) {
                vm.siteAsset.positionX = siteAsset.positionX;
                vm.siteAsset.positionY = siteAsset.positionY;
                if (vm.origSiteAsset) {
                    vm.origSiteAsset.positionX = siteAsset.positionX;
                    vm.origSiteAsset.positionY = siteAsset.positionY;
                }
            }
        }
    });

    function reload(siteAssetId, siteAssetType) {
        if (!vm.siteAsset || !angular.equals(vm.siteAsset.id, siteAssetId)) {
            vm.loading = true;
            vm.origSiteAsset = null;
            vm.siteAsset = null;
            if (siteAssetId && siteAssetType) {
                var getSiteAssetPromise;
                if (siteAssetType === agTypes.assetType.silo) {
                    getSiteAssetPromise = siloService.getSilo(siteAssetId);
                } else if (siteAssetType === agTypes.assetType.siloGroup) {
                    getSiteAssetPromise = siloGroupService.getSiloGroup(siteAssetId);
                } else if (siteAssetType === agTypes.assetType.aeration) {
                    getSiteAssetPromise = aerationService.getAeration(siteAssetId, true);
                } else if (siteAssetType === agTypes.assetType.weatherStation) {
                    getSiteAssetPromise = weatherStationService.getWeatherStation(siteAssetId);
                }
                if (getSiteAssetPromise) {
                    getSiteAssetPromise.then(
                        function success(siteAsset) {
                            vm.origSiteAsset = siteAsset;
                            vm.siteAsset = angular.copy(siteAsset);
                            vm.loading = false;
                            resetFormState();
                        }
                    );
                } else {
                    vm.loading = false;
                }
            } else {
                vm.loading = false;
            }
        }
    }

    function resetFormState() {
        $timeout(function() {
            if ($scope.theForm.updateValidity) {
                $scope.theForm.updateValidity();
            }
            $scope.theForm.$setPristine();
            $scope.theForm.$setUntouched();
        });
    }

    function moveNameId () {
        if (vm.siteAsset) {
            if (vm.siteAsset.type === agTypes.assetType.silo) {
                return 'ag.silo.move';
            } else if (vm.siteAsset.type === agTypes.assetType.siloGroup) {
                return 'ag.silo-group.move';
            } else if (vm.siteAsset.type === agTypes.assetType.aeration) {
                return 'ag.aeration.move';
            } else if (vm.siteAsset.type === agTypes.assetType.weatherStation) {
                return 'ag.weather-station.move';
            }
        } else {
            return null;
        }
    }

    function detailsNameId () {
        if (vm.siteAsset) {
            if (vm.siteAsset.type === agTypes.assetType.silo) {
                return 'ag.silo.details';
            } else if (vm.siteAsset.type === agTypes.assetType.siloGroup) {
                return 'ag.silo-group.details';
            } else if (vm.siteAsset.type === agTypes.assetType.aeration) {
                return 'ag.aeration.details';
            } else if (vm.siteAsset.type === agTypes.assetType.weatherStation) {
                return 'ag.weather-station.details';
            }
        } else {
            return null;
        }
    }

    function copySiteAsset($event) {
        var copyDialogPromise;
        if (vm.siteAsset.type === agTypes.assetType.silo) {
            copyDialogPromise = siloService.copySiloDialog($event, vm.origSiteAsset);
        } else if (vm.siteAsset.type === agTypes.assetType.weatherStation) {
            copyDialogPromise = weatherStationService.copyWeatherStationDialog($event, vm.origSiteAsset);
        }
        if (copyDialogPromise) {
            copyDialogPromise.then(
                function() {
                    $rootScope.$broadcast('siteAssetCopied');
                }
            );
        }
    }

    function moveSiteAsset($event) {
        var moveDialogPromise;
        if (vm.siteAsset.type === agTypes.assetType.silo) {
            moveDialogPromise = siloService.moveSiloDialog($event, vm.origSiteAsset, vm.ctx.stateController.getStateParams().entityId);
        } else if (vm.siteAsset.type === agTypes.assetType.siloGroup) {
            moveDialogPromise = siloGroupService.moveSiloGroupDialog($event, vm.origSiteAsset, vm.ctx.stateController.getStateParams().entityId);
        } else if (vm.siteAsset.type === agTypes.assetType.aeration) {
            moveDialogPromise = aerationService.moveAerationDialog($event, vm.origSiteAsset, vm.ctx.stateController.getStateParams().entityId);
        } else if (vm.siteAsset.type === agTypes.assetType.weatherStation) {
            moveDialogPromise = weatherStationService.moveWeatherStationDialog($event, vm.origSiteAsset, vm.ctx.stateController.getStateParams().entityId);
        }
        if (moveDialogPromise) {
            moveDialogPromise.then(
                function() {
                    reload();
                    $rootScope.$broadcast('siteAssetMoved');
                }
            );
        }
    }

    function gotoSiteAssetDetails($event) {
        if ($event) {
            $event.stopPropagation();
        }
        var params = {
            entityId: vm.siteAsset.id
        };
        var targetState;
        if (vm.siteAsset.type === agTypes.assetType.silo) {
            targetState = agTypes.adminState.silo;
        } else if (vm.siteAsset.type === agTypes.assetType.siloGroup) {
            targetState = agTypes.adminState.siloGroup;
        } else if (vm.siteAsset.type === agTypes.assetType.aeration) {
            targetState = agTypes.adminState.aeration;
        } else if (vm.siteAsset.type === agTypes.assetType.weatherStation) {
            targetState = agTypes.adminState.weatherStation;
        }
        if (targetState) {
            vm.ctx.stateController.openState(targetState, params);
        }
    }

    function cancel() {
        vm.siteAsset = angular.copy(vm.origSiteAsset);
        resetFormState();
    }

    function save() {
        var saveSiteAssetPromise;
        if (vm.siteAsset.type === agTypes.assetType.silo) {
            saveSiteAssetPromise = siloService.saveSilo(vm.siteAsset);
        } else if (vm.siteAsset.type === agTypes.assetType.siloGroup) {
            saveSiteAssetPromise = siloGroupService.saveSiloGroup(vm.siteAsset);
        } else if (vm.siteAsset.type === agTypes.assetType.aeration) {
            saveSiteAssetPromise = aerationService.saveAeration(vm.siteAsset);
        } else if (vm.siteAsset.type === agTypes.assetType.weatherStation) {
            saveSiteAssetPromise = weatherStationService.saveWeatherStation(vm.siteAsset);
        }
        var valid = !$scope.theForm.updateValidity || $scope.theForm.updateValidity && $scope.theForm.updateValidity();
        if (valid && saveSiteAssetPromise) {
            saveSiteAssetPromise.then(function success(siteAsset) {
                if (vm.siteAsset.type === agTypes.assetType.aeration && vm.origSiteAsset.gatewayDeviceId !== vm.siteAsset.gatewayDeviceId) {
                    let aerationRelationsTasks = [];
                    let newRelation = {
                        from: {id: vm.siteAsset.gatewayDeviceId, entityType: types.entityType.device},
                        to: vm.siteAsset.id,
                        type: types.entityRelationType.contains
                    };
                    if (vm.origSiteAsset.gatewayDeviceId) {
                        aerationRelationsTasks.push(entityRelationService.deleteRelation(vm.origSiteAsset.gatewayDeviceId, types.entityType.device, types.entityRelationType.contains,
                            siteAsset.id.id, siteAsset.id.entityType));
                    }
                    aerationRelationsTasks.push(entityRelationService.saveRelation(newRelation));
                    $q.all(aerationRelationsTasks).then(
                        () => {
                            updateAssetAndForm(siteAsset);
                        }
                    );
                } else {
                    updateAssetAndForm(siteAsset);
                }
            });
        }
    }

    function updateAssetAndForm(siteAsset) {
        vm.origSiteAsset = siteAsset;
        vm.siteAsset = angular.copy(siteAsset);
        $scope.theForm.$setPristine();
        $scope.theForm.$setUntouched();
        $rootScope.$broadcast('siteAssetUpdated', vm.origSiteAsset);
    }
}

